// use localStorage to store the authority info, which might be sent from server in actual project.
export function getAuthority() {
  // return localStorage.getItem('antd-pro-authority') || ['admin', 'user'];
  const authorityString = sessionStorage.getItem("client-authority");
  // authorityString could be admin, "admin", ["admin"]
  if(authorityString == null){
    return null;
  }
  let authority;
  try {
    authority = JSON.parse(authorityString);
  } catch (e) {
    authority = authorityString;
  }
  return authority;
}

export function setAuthority(authority) {
  return sessionStorage.setItem(
    "client-authority",
    JSON.stringify(authority)
  );
}

export function clearAuthority() {
  sessionStorage.clear();
}